import script from "./PlanSelection20676.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanSelection20676.vue?vue&type=script&setup=true&lang=ts"

import "./PlanSelection20676.vue?vue&type=style&index=0&id=0ed698de&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ed698de"]])

export default __exports__